import { toast } from 'react-toastify';

const toastAlert = (type, message, toastId) => {
    if (!['success', 'error', 'info', 'warning'].includes(type)) return false;
    return toast[type](message, {
        autoClose: 2000,
        toastId: toastId,
        position: toast.POSITION.TOP_RIGHT
    });
}

export default toastAlert;